/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

function saveGridItemData(collectionTitle, collectionURL, productHandle) {
  window.localStorage.setItem("breadcrumbsPDP", JSON.stringify({
    collection_title: collectionTitle,
    collection_url: collectionURL,
    product_handle: productHandle
  }));
}

window.addEventListener("theme:cart:added", async function() {
  const cart = await(await fetch("https://looplabb.com/cart.js")).json();
  const itemCountElements = document.querySelectorAll(".cart__bubble-item");



  for(const el of itemCountElements) {
    el.innerText = cart.item_count;
  }

  const drawerTotalPrice = document.querySelector(".cart-drawer__foot--subtotal");
  drawerTotalPrice.children[1].innerText = `${window.theme.formatMoney(cart.total_price, theme.moneyFormat) }`;
});

class CustomFilterButton extends HTMLElement {
  #filterParams = this.dataset.params.split("|");
  #filterMap = new Map();

  constructor() {
    super();
    this.#createFilterObj();
    this.addEventListener("click", this.applyFilters.bind(this));
  }

  #createFilterObj() {
    if(this.#filterParams) {
      for(const filterParam of this.#filterParams) {
        const param = filterParam.split("=")[0];
        const value = filterParam.split("=")[1];

        if(!this.#filterMap.get(param)) {
          this.#filterMap.set(param, []);
        }

        this.#filterMap.get(param).push(value);
      }
    }
  }

  applyFilters() {
    const filterContainer = document.querySelector("form[data-collection-filters-form]");

    if(filterContainer) {
      for(const param of this.#filterMap.keys()) {
        const elements = filterContainer.querySelectorAll(`.filter__input[name="${param}"]`);
        const valuesArr = this.#filterMap.get(param);

        for(const element of elements) {
          const value = element.getAttribute("value");
          if(valuesArr.includes(value)) {
            if(!element.checked) {
              element.click();
            }
          } else {
            if(element.checked) {
              element.click();
            }
          }
        }
      }
    }
  }
} 

customElements.define("custom-filter-button", CustomFilterButton);

window.addEventListener("DOMContentLoaded", function() {
  /* PRODUCT GALLERY BUTTON */
  const galleryBtn = document.querySelector(".product-gallery--more");
  if(galleryBtn) {
    galleryBtn.addEventListener("click", function() {
      galleryBtn.parentElement.classList.remove("hide-images");
      galleryBtn.style.display = "none";
    });
  }

  /* COLLECTION FILTER */
  const filterBtn = document.querySelector(".collection--desktop-filter-btn");
  const filterContainer = document.querySelector(".collection__filters");
  if(filterBtn && filterContainer) {
    filterBtn.addEventListener("click", function() {
      if(filterBtn.getBoundingClientRect().top == 10) {
        filterContainer.style.setProperty("--sticky-height", `${filterBtn.parentElement.getBoundingClientRect().height}px`);
      } else {
        filterContainer.style.setProperty("--sticky-height", 0);
      }
      filterBtn.classList.toggle("hide");
      filterContainer.classList.toggle("hide");
    });
  }
});

class RAOQuickBuy extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const form = this.querySelector("form");
    const idInput = form.querySelector(`input[name="id"]`);
    const container = this.parentElement;

    container.style.setProperty("--quick-buy-height", `-${this.getBoundingClientRect().height / 2}px`);

    form.addEventListener("change", function(e) {
      idInput.value = e.target.value;
      form.classList.remove("red-border");
    });
  }
}

customElements.define("rao-quick-buy", RAOQuickBuy);

class RAOQuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const form = this.querySelector("form");
    const idInput = form.querySelector(`input[name="id"]`);

    form.addEventListener("change", function(e) {
      idInput.value = e.target.value;
      form.classList.remove("red-border");
    });
  }
}

customElements.define("rao-quick-view", RAOQuickView);

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.movementInit();
    this.desktopInit();
    this.mobileInit();
  }

  movementInit() {
    const atc = document.querySelector(".product__form__wrapper");
    const footer = document.querySelector(".rao-footer--section");

    window.addEventListener("scroll", function() {
      if(atc.getBoundingClientRect().bottom <= 0 && footer.getBoundingClientRect().top > window.innerHeight) {
        this.classList.add("show");
      } else {
        this.classList.remove("show");
      }
    }.bind(this));
  }

  mobileInit() {
    const stickyForm = this.querySelector(".sticky__mobile--right");
    const addToCartInput = this.querySelector(`.sticky--mobile input[name="id"]`);
    const variantBtn = this.querySelector(".sticky__mobile--variant-btn");
    const variantValue = this.querySelector(".sticky__mobile--variant-value");
    let firstVariantChange = true;

    variantBtn.addEventListener("click", this.scrollToForm.bind(this));
    variantValue.addEventListener("click", this.scrollToForm.bind(this));

    window.addEventListener("theme:variant:change", function(e) {
      if(!firstVariantChange) {
        variantValue.innerText = e.detail.variant.option2;
        stickyForm.classList.remove("variants-hide");
        addToCartInput.value = e.detail.variant.id;
      }
      firstVariantChange = false;
    });
  }

  desktopInit() {
    this.form = document.querySelector(".product__form__wrapper");
    const stickyForm = this.querySelector(".sticky__desktop--form");
    const addToCartInput = this.querySelector(`.sticky--desktop input[name="id"]`);
    const variantBtn = this.querySelector(".sticky__desktop--variant-btn");
    const variantValue = this.querySelector(".sticky__desktop--variant-value");
    let firstVariantChange = true;

    variantBtn.addEventListener("click", this.scrollToForm.bind(this));
    variantValue.addEventListener("click", this.scrollToForm.bind(this));

    window.addEventListener("theme:variant:change", function(e) {
      if(!firstVariantChange) {
        variantValue.innerText = e.detail.variant.option2;
        stickyForm.classList.remove("variants-hide");
        addToCartInput.value = e.detail.variant.id;
      }
      firstVariantChange = false;
    });
  }

  scrollToForm() {
    this.form.scrollIntoView({behavior: "smooth", block: "center"});
  }
}

customElements.define("sticky-add-to-cart", StickyAddToCart);

class SwatchFiltersCollapsible extends HTMLElement {
  constructor() {
    super();
    this.rows = Number(this.dataset.showRows);
    this.height = Number(this.dataset.elementHeight);
    this.mobileHeight = Number(this.dataset.elementMobileHeight);
    this.totalShowRowsHeight = this.rows * this.height;
    this.collapsedHeight = this.height;
    this.totalShowRowsMobileHeight = this.rows * this.mobileHeight;
    this.blockHeight = this.offsetHeight;
    this.block = this.querySelector("[swatch-filters-block]");
    this.moreBtn = this.querySelector(".collection__filters-more");
  }

  connectedCallback() {
    this.init();
    window.addEventListener("resize", this.init.bind(this));
  }

  init() {
    this.block.style.maxHeight = `max-content`;
    this.blockHeight = this.offsetHeight;
    if (window.innerWidth < 768) {
      this.initMobile();
    } else {
      this.initDesktop();
    }
  }

  initMobile() {
    if (this.totalShowRowsMobileHeight < this.blockHeight) {
      this.block.style.maxHeight = `${this.totalShowRowsMobileHeight}px`;
      this.collapsedHeight = this.totalShowRowsMobileHeight;
      this.block.style.overflow = "hidden";
      this.moreBtn.classList.remove("hidden");
      this.moreBtn.addEventListener("click", this.toggle.bind(this));
    }
  }

  initDesktop() {
    if (this.totalShowRowsHeight < this.blockHeight) {
      this.block.style.maxHeight = `${this.totalShowRowsHeight}px`;
      this.collapsedHeight = this.totalShowRowsHeight;
      this.block.style.overflow = "hidden";
      this.moreBtn.classList.remove("hidden");
      this.moreBtn.addEventListener("click", this.toggle.bind(this));
    }
  }

  toggle() {
    if (this.moreBtn.classList.contains("is-expanded")) {
      this.moreBtn.classList.remove("is-expanded");
      this.block.style.maxHeight = `${this.collapsedHeight}px`;
    } else {
      this.moreBtn.classList.add("is-expanded");
      this.block.style.maxHeight = `${this.blockHeight}px`;
    }
  }
} 

customElements.define("swatch-filters-collapsible", SwatchFiltersCollapsible);

